import { ofType } from "redux-observable";
import { of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import { fetchSODConflictsBR } from "../../../../common/SODUtils/SODservices";
import {
  actionTypes,
  adminSodConflictsActionBRFailure,
  adminSodConflictsActionBRSuccess,
  createAdminBRRequestFailure,
  createAdminBRRequestSuccess,
  deleteBrRequestFailure,
  deleteBRRequestSuccess,
  getBrEntitlementRequestFailure,
  getBrEntitlementRequestSuccess,
  getBRRequestFailure,
  getBRRequestSuccess,
  getEntitlementRequestFailure,
  getEntitlementRequestSuccess,
  getPaginatedOuRequestFailure,
  getPaginatedOuRequestSuccess,
  modifyAdminBRRequestFailure,
  modifyAdminBRRequestSuccess,
} from "./actions";
import {
  createAdminBRRequest,
  fetchAdminDeleteBRRequest,
  fetchBRByOfficeRequest,
  fetchEntitlementsByOuRequest,
  fetchPaginatedOU,
  getAdminBrEntitlements,
  modifyAdminBRRequest,
} from "./services";

const fetchPaginatedOUEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_BR_OU_REQUEST),
    mergeMap((action: any) =>
      fetchPaginatedOU(action.payload).pipe(
        map((response: any) => getPaginatedOuRequestSuccess(response)),
        catchError((error: any) => of(getPaginatedOuRequestFailure(error)))
      )
    )
  );

const fetchBRByOfficeRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_BR_BR_REQUEST),
    mergeMap((action: any) =>
      fetchBRByOfficeRequest(action.payload).pipe(
        map((response: any) => getBRRequestSuccess(response)),
        catchError((error: any) => of(getBRRequestFailure(error)))
      )
    )
  );

const fetchOuEntitlementRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_BR_ENTITLEMENT_REQUEST),
    mergeMap((action: any) =>
      fetchEntitlementsByOuRequest(action.payload).pipe(
        map((response: any) => getEntitlementRequestSuccess(response)),
        catchError((error: any) => of(getEntitlementRequestFailure(error)))
      )
    )
  );

const fetchAdminSODConflictsBREpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.SOD_CONFLICTS_ADMIN_BR),
    mergeMap((action: any) =>
      fetchSODConflictsBR(action.payload).pipe(
        map((response: any) => adminSodConflictsActionBRSuccess(response)),
        catchError((error: any) => of(adminSodConflictsActionBRFailure(error)))
      )
    )
  );

const createAdminBRRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_BR_MGMT_CREATE_REQUEST),
    mergeMap((action: any) =>
      createAdminBRRequest(action.payload).pipe(
        map((response: any) => createAdminBRRequestSuccess(response)),
        catchError((error: any) => of(createAdminBRRequestFailure(error)))
      )
    )
  );

const modifyAdminBRRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_BR_MGMT_MODIFY_REQUEST),
    mergeMap((action: any) =>
      modifyAdminBRRequest(action.payload).pipe(
        map((response: any) => modifyAdminBRRequestSuccess(response)),
        catchError((error: any) => of(modifyAdminBRRequestFailure(error)))
      )
    )
  );

const deleteBRRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_BR_DELETE_BR_REQUEST),
    mergeMap((action: any) =>
      fetchAdminDeleteBRRequest(
        action.payload.codeBR,
        action.payload.attachments
      ).pipe(
        map((response: any) => deleteBRRequestSuccess(response)),
        catchError((error: any) => of(deleteBrRequestFailure(error)))
      )
    )
  );

const getAdminBrEntitlementsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_BR_GET_BE_ENTITLEMENTS_REQUEST),
    mergeMap((action: any) =>
      getAdminBrEntitlements(action.payload).pipe(
        map((response: any) => getBrEntitlementRequestSuccess(response)),
        catchError((error: any) => of(getBrEntitlementRequestFailure(error)))
      )
    )
  );

export default [
  fetchPaginatedOUEpic,
  fetchBRByOfficeRequestEpic,
  fetchOuEntitlementRequestEpic,
  fetchAdminSODConflictsBREpic,
  createAdminBRRequestEpic,
  getAdminBrEntitlementsEpic,
  modifyAdminBRRequestEpic,
  deleteBRRequestEpic,
];
